export default "__VITE_ASSET__CoE7BMzj__"